import { useState } from "react";

export const AccordionItem = ({ title, children }) => {
    const [open, setOpen] = useState(false);

    return (
        <div className="border-b border-white/10 py-6">
            <button
                onClick={() => setOpen(!open)}
                className="w-full flex justify-between items-center text-left group"
            >
                <span className="text-lg md:text-xl font-semibold group-hover:text-cyan-400 transition">
                    {title}
                </span>

                <span className="text-slate-400 text-xl">
                    {open ? "−" : "+"}
                </span>
            </button>

            <div
                className={`transition-all duration-300 overflow-hidden ${open ? "max-h-40 mt-4" : "max-h-0"
                    }`}
            >
                <p className="text-slate-400 text-[15px] leading-relaxed">
                    {children}
                </p>
            </div>
        </div>
    );
};